import { toast } from "react-toastify";
import { generateRandomString } from "./constants";

const custom_error = "Something went wrong!";

let toastId = null;

export const toastContainer = (
  message = custom_error,
  variant,
  id = generateRandomString(10),
  options = {}
) => {
  const customStyle = typeof variant == "object" ? variant : null;

  dismissToast();

  toastId = id;

  setTimeout(() => {
    toast(message, {
      toastId: toastId,
      type: customStyle == null ? variant : "default",
      style: customStyle ? customStyle : undefined,
      // autoClose: 2000,
      autoClose: 200000,
      closeOnClick:false,
      // dismiss: toast.dismiss()
      ...options
    });
  }, 1000);
};

export const dismissToast = () => {
  toast.dismiss(toastId);
};

export const isActiveToast = ()=>{
  return toast.isActive(toastId)
}
